import { render, staticRenderFns } from "./GiftCardDetails.vue?vue&type=template&id=5330f3b9&scoped=true"
import script from "./GiftCardDetails.vue?vue&type=script&lang=js"
export * from "./GiftCardDetails.vue?vue&type=script&lang=js"
import style0 from "./GiftCardDetails.vue?vue&type=style&index=0&id=5330f3b9&prod&lang=css"
import style1 from "./GiftCardDetails.vue?vue&type=style&index=1&id=5330f3b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5330f3b9",
  null
  
)

export default component.exports